export const GET_SEJOURS_MODELS_EVENTS_PRICES = "sejours/GET_SEJOURS_MODELS_EVENTS_PRICES";
export const UPDATE_SEJOURS_MODELS_EVENTS_PRICES = "sejours/UPDATE_SEJOURS_MODELS_EVENTS_PRICES";
export const DELETE_SEJOURS_MODELS_EVENTS_PRICES = "sejours/DELETE_SEJOURS_MODELS_EVENTS_PRICES";